/* Football Masters market attribution bridge.
 * Persists UTM/click IDs and writes them to Shopify cart attributes before checkout.
 */
(function () {
  "use strict";

  if (window.__fmAttributionLoaded) return;
  window.__fmAttributionLoaded = true;

  var VERSION = "2026-06-27.full-funnel-attribution-v2";
  var STORAGE_KEY = "fmAttribution.v1";
  var MAX_VALUE_LENGTH = 512;
  var PARAM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "ttclid",
    "msclkid",
    "campaign_id",
    "ad_id",
    "adset_id",
    "fm_market",
    "discount"
  ];
  var CLICK_ID_KEYS = ["gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"];
  var SOURCE_PARAM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "ttclid",
    "msclkid",
    "campaign_id",
    "ad_id",
    "adset_id"
  ];
  var CONTEXT_PARAM_KEYS = ["fm_market", "discount"];

  var MARKETS = {
    cz: {
      hosts: ["footballmasters.cz", "www.footballmasters.cz"],
      lang: /^cs/i,
      pathPrefix: /^\/cs(\/|$)/i,
      currency: "CZK",
      discount: "CZGK50"
    },
    sk: {
      hosts: ["footballmasters.sk", "www.footballmasters.sk"],
      lang: /^sk/i,
      pathPrefix: /^\/sk(\/|$)/i,
      currency: "EUR",
      discount: "SKGK50"
    },
    ro: {
      hosts: ["footballmasters.ro", "www.footballmasters.ro"],
      lang: /^ro/i,
      pathPrefix: /^\/ro-ro(\/|$)/i,
      currency: "RON",
      discount: "ROGK50"
    },
    de: {
      hosts: ["footballmasters.com.de", "www.footballmasters.com.de"],
      lang: /^de/i,
      pathPrefix: /^\/de(\/|$)/i,
      currency: "EUR",
      discount: "DEGK50"
    }
  };

  function clean(value, maxLength) {
    var next = String(value || "").replace(/\s+/g, " ").trim();
    return next.slice(0, maxLength || MAX_VALUE_LENGTH);
  }

  function getMarket() {
    var host = (window.location.hostname || "").toLowerCase();
    var path = window.location.pathname || "/";
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    var keys = Object.keys(MARKETS);
    for (var index = 0; index < keys.length; index += 1) {
      var market = keys[index];
      var config = MARKETS[market];
      if (config.hosts.indexOf(host) !== -1 || config.pathPrefix.test(path) || config.lang.test(lang)) {
        return {
          code: market,
          currency: config.currency,
          discount: config.discount
        };
      }
    }
    return {
      code: "pro",
      currency: "PLN",
      discount: ""
    };
  }

  function readStorage() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) || {} : {};
    } catch (error) {
      return {};
    }
  }

  function writeStorage(payload) {
    try {
      if (window.localStorage) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {}
  }

  function pageUrl() {
    try {
      var url = new URL(window.location.href);
      url.hash = "";
      return url.toString();
    } catch (error) {
      return window.location.href || "";
    }
  }

  function readIncomingParams() {
    var incoming = {};
    try {
      var params = new URLSearchParams(window.location.search || "");
      PARAM_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) incoming[key] = clean(value, 255);
      });
    } catch (error) {}
    return incoming;
  }

  function externalReferrerHost(referrer) {
    try {
      var url = new URL(referrer || "");
      var currentHost = (window.location.hostname || "").toLowerCase();
      var refHost = (url.hostname || "").toLowerCase();
      if (!refHost || refHost === currentHost || refHost === "www." + currentHost) return "";
      return clean(refHost.replace(/^www\./, ""), 128);
    } catch (error) {
      return "";
    }
  }

  function hasSourceSignal(params, refHost) {
    return SOURCE_PARAM_KEYS.some(function (key) {
      return Boolean(params[key]);
    }) || Boolean(refHost);
  }

  function clickIdType(params) {
    for (var index = 0; index < CLICK_ID_KEYS.length; index += 1) {
      if (params[CLICK_ID_KEYS[index]]) return CLICK_ID_KEYS[index];
    }
    return "";
  }

  function clickIdValue(params) {
    var key = clickIdType(params);
    return key ? params[key] : "";
  }

  function inferredSource(params, refHost) {
    if (params.utm_source) return params.utm_source;
    if (params.gclid || params.gbraid || params.wbraid) return "google";
    if (params.fbclid) return "meta";
    if (params.ttclid) return "tiktok";
    if (params.msclkid) return "bing";
    if (refHost) return refHost;
    return "";
  }

  function inferredMedium(params, refHost) {
    if (params.utm_medium) return params.utm_medium;
    if (params.gclid || params.gbraid || params.wbraid || params.msclkid) return "cpc";
    if (params.fbclid || params.ttclid) return "paid_social";
    if (refHost) return "referral";
    return "";
  }

  function sourceQuality(params, refHost) {
    if (clickIdType(params)) return "paid_click_id";
    if (params.utm_source || params.utm_medium || params.utm_campaign) return "utm";
    if (refHost) return "referrer";
    return "direct_or_unknown";
  }

  function captureAttribution() {
    var market = getMarket();
    var stored = readStorage();
    var now = new Date().toISOString();
    var current = pageUrl();
    var params = readIncomingParams();
    var refHost = externalReferrerHost(document.referrer || "");
    var hasIncoming = hasSourceSignal(params, refHost);

    if (!stored.first_seen_at) stored.first_seen_at = now;
    if (!stored.first_landing_url) stored.first_landing_url = current;
    if (!stored.first_referrer && document.referrer) stored.first_referrer = clean(document.referrer);
    if (!stored.first_market) stored.first_market = market.code;
    if (!stored.context_params) stored.context_params = {};
    CONTEXT_PARAM_KEYS.forEach(function (key) {
      if (params[key]) stored.context_params[key] = params[key];
    });
    if (!stored.context_params.fm_market) stored.context_params.fm_market = market.code;
    if (!stored.context_params.discount && market.discount) stored.context_params.discount = market.discount;

    stored.last_seen_at = now;
    stored.last_landing_url = current;
    stored.last_referrer = clean(document.referrer || stored.last_referrer || "");
    stored.last_referrer_host = refHost || stored.last_referrer_host || "";
    stored.last_market = market.code;
    stored.last_currency = market.currency;

    if (hasIncoming) {
      if (!stored.first_touch_params) stored.first_touch_params = params;
      stored.last_touch_params = params;
      stored.last_referrer_host = refHost;
    } else if (!stored.last_touch_params) {
      stored.last_touch_params = {};
    }

    writeStorage(stored);
    return stored;
  }

  function buildAttributes(reason) {
    var market = getMarket();
    var stored = captureAttribution();
    var params = stored.last_touch_params || {};
    var firstParams = stored.first_touch_params || {};
    var context = stored.context_params || {};
    var lastRefHost = stored.last_referrer_host || externalReferrerHost(stored.last_referrer || "");
    var firstRefHost = externalReferrerHost(stored.first_referrer || "");
    var lastSource = clean(inferredSource(params, lastRefHost), 128);
    var firstSource = clean(inferredSource(firstParams, firstRefHost), 128);
    var effectiveSource = lastSource || firstSource || "direct";
    var lastMedium = clean(inferredMedium(params, lastRefHost), 128);
    var firstMedium = clean(inferredMedium(firstParams, firstRefHost), 128);
    var effectiveMedium = lastMedium || firstMedium || "none";
    var quality = sourceQuality(params, lastRefHost);
    if (quality === "direct_or_unknown" && (firstSource || firstMedium)) {
      quality = sourceQuality(firstParams, firstRefHost);
    }
    var missingReason = quality === "direct_or_unknown" ? "no_utm_click_id_or_external_referrer" : "";
    return {
      fm_attr_version: VERSION,
      fm_attr_reason: clean(reason || "storefront", 64),
      fm_market: clean(context.fm_market || params.fm_market || stored.last_market || market.code, 32),
      fm_currency: clean(stored.last_currency || market.currency, 16),
      fm_discount_code: clean((context.discount || params.discount || market.discount || "").toUpperCase(), 32),
      fm_landing_url: clean(stored.first_landing_url || stored.last_landing_url || pageUrl()),
      fm_current_url: clean(stored.last_landing_url || pageUrl()),
      fm_referrer: clean(stored.first_referrer || stored.last_referrer || document.referrer || ""),
      fm_first_seen_at: clean(stored.first_seen_at || "", 64),
      fm_last_seen_at: clean(stored.last_seen_at || "", 64),
      fm_utm_source: clean(effectiveSource, 128),
      fm_utm_medium: clean(effectiveMedium, 128),
      fm_utm_campaign: clean(params.utm_campaign || firstParams.utm_campaign || "", 255),
      fm_utm_content: clean(params.utm_content || firstParams.utm_content || "", 255),
      fm_utm_term: clean(params.utm_term || firstParams.utm_term || "", 255),
      fm_gclid: clean(params.gclid || firstParams.gclid || params.gbraid || params.wbraid || "", 255),
      fm_fbclid: clean(params.fbclid || firstParams.fbclid || "", 255),
      fm_ttclid: clean(params.ttclid || firstParams.ttclid || "", 255),
      fm_msclkid: clean(params.msclkid || firstParams.msclkid || "", 255),
      fm_campaign_id: clean(params.campaign_id || firstParams.campaign_id || "", 128),
      fm_adset_id: clean(params.adset_id || firstParams.adset_id || "", 128),
      fm_ad_id: clean(params.ad_id || firstParams.ad_id || "", 128),
      fm_attr_first_source: clean(firstSource || effectiveSource, 128),
      fm_attr_first_medium: clean(firstMedium || effectiveMedium, 128),
      fm_attr_first_campaign: clean(firstParams.utm_campaign || "", 255),
      fm_attr_first_content: clean(firstParams.utm_content || "", 255),
      fm_attr_first_term: clean(firstParams.utm_term || "", 255),
      fm_attr_last_source: clean(lastSource || effectiveSource, 128),
      fm_attr_last_medium: clean(lastMedium || effectiveMedium, 128),
      fm_attr_last_campaign: clean(params.utm_campaign || "", 255),
      fm_attr_last_content: clean(params.utm_content || "", 255),
      fm_attr_last_term: clean(params.utm_term || "", 255),
      fm_attr_click_id_type: clean(clickIdType(params) || clickIdType(firstParams), 32),
      fm_attr_click_id: clean(clickIdValue(params) || clickIdValue(firstParams), 255),
      fm_attr_source_quality: clean(quality, 64),
      fm_attr_missing_source_reason: clean(missingReason, 128),
      fm_attr_referrer_host: clean(lastRefHost || firstRefHost, 128)
    };
  }

  function compactAttributes(attributes) {
    var next = {};
    Object.keys(attributes || {}).forEach(function (key) {
      var value = clean(attributes[key]);
      if (value) next[key] = value;
    });
    return next;
  }

  function upsertHidden(form, name, value) {
    if (!form || !name || !value) return;
    var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    input.value = clean(value);
  }

  function decorateForms(root) {
    if (!root || !root.querySelectorAll) return;
    var attributes = compactAttributes(buildAttributes("form_decorate"));
    root.querySelectorAll("form[action]").forEach(function (form) {
      var action = form.getAttribute("action") || "";
      if (/\/cart\/add/i.test(action)) {
        [
          "fm_market",
          "fm_currency",
          "fm_discount_code",
          "fm_utm_source",
          "fm_utm_medium",
          "fm_utm_campaign",
          "fm_utm_content",
          "fm_utm_term",
          "fm_gclid",
          "fm_fbclid",
          "fm_ttclid",
          "fm_campaign_id",
          "fm_adset_id",
          "fm_ad_id",
          "fm_attr_last_source",
          "fm_attr_last_medium",
          "fm_attr_last_campaign",
          "fm_attr_first_source",
          "fm_attr_first_medium",
          "fm_attr_first_campaign",
          "fm_attr_source_quality",
          "fm_attr_missing_source_reason",
          "fm_attr_click_id_type"
        ].forEach(function (key) {
          upsertHidden(form, "properties[_" + key + "]", attributes[key]);
        });
      }
      if (/\/cart(?:\/|$|\?)/i.test(action)) {
        Object.keys(attributes).forEach(function (key) {
          upsertHidden(form, "attributes[" + key + "]", attributes[key]);
        });
      }
    });
  }

  var syncInFlight = false;
  function syncCartAttributes(reason) {
    if (syncInFlight) return Promise.resolve(false);
    syncInFlight = true;
    var attributes = compactAttributes(buildAttributes(reason));
    window.__fmAttributionState = {
      version: VERSION,
      market: attributes.fm_market || getMarket().code,
      attributes: attributes
    };

    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "content-type": "application/json",
        "accept": "application/json"
      },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        return response && response.ok;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        syncInFlight = false;
      });
  }

  function bindEvents() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.action) return;
      decorateForms(form.parentElement || document);
      if (/\/cart\/add/i.test(form.action)) {
        syncCartAttributes("cart_add_submit");
      } else if (/\/cart/i.test(form.action) && event.submitter && event.submitter.name === "checkout") {
        syncCartAttributes("checkout_submit");
      }
    }, true);

    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest ? event.target.closest("a, button, input[type='submit']") : null;
      if (!target) return;
      var href = target.getAttribute("href") || "";
      var name = target.getAttribute("name") || "";
      var value = target.getAttribute("value") || "";
      var text = target.textContent || "";
      if (/\/checkout/i.test(href) || name === "checkout" || /checkout|pokladna|pokladne|pokladny|finalizare|kasse/i.test(value + " " + text)) {
        decorateForms(document);
        syncCartAttributes("checkout_click");
      }
    }, true);

    var originalFetch = window.fetch;
    if (originalFetch && !window.__fmAttributionFetchPatched) {
      window.__fmAttributionFetchPatched = true;
      window.fetch = function () {
        var request = arguments[0];
        var url = typeof request === "string" ? request : request && request.url;
        var isCartAdd = url && /\/cart\/add/i.test(url);
        return originalFetch.apply(this, arguments).then(function (response) {
          if (isCartAdd && response && response.ok) {
            syncCartAttributes("cart_add_fetch");
          }
          return response;
        });
      };
    }
  }

  captureAttribution();
  decorateForms(document);
  syncCartAttributes("page_view");
  bindEvents();

  var timer = null;
  new MutationObserver(function () {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      decorateForms(document);
    }, 120);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.__fmAttributionVersion = VERSION;
})();
